// Essential polyfills - must be first
import process from 'process';
import { Readable, Writable, Duplex, Transform, PassThrough } from 'readable-stream';
import 'assert';
import 'path-browserify';
import 'url';
import 'crypto-browserify';

// Define the type for our exports
interface GlobalExports {
  process: typeof process;
  global: typeof window | typeof globalThis;
  Stream?: {
    Readable: typeof Readable;
    Writable: typeof Writable;
    Duplex: typeof Duplex;
    Transform: typeof Transform;
    PassThrough: typeof PassThrough;
  };
  TextEncoder?: typeof TextEncoder;
  TextDecoder?: typeof TextDecoder;
  [key: string]: any; // Allow string indexing
}

// Create a global module object with exports
const globalModule = {
  exports: {} as GlobalExports,
  id: '<polyfills>',
  loaded: true,
  require: function (id: string) {
    return globalModule.exports[id];
  }
};

// Initialize global objects first
if (typeof window !== 'undefined') {
  // Ensure process.env is available before anything else
  if (!(window as any).process) {
    (window as any).process = process;
  }
  if (!(window as any).process.env) {
    (window as any).process.env = {};
  }
  if (!(globalThis as any).process) {
    (globalThis as any).process = process;
  }
  if (!(globalThis as any).process.env) {
    (globalThis as any).process.env = {};
  }

  // Global object
  (window as any).global = window;
  (globalThis as any).global = globalThis;

  // Initialize module and exports
  (window as any).module = globalModule;
  (window as any).exports = globalModule.exports;
  (globalThis as any).module = globalModule;
  (globalThis as any).exports = globalModule.exports;
}

// Add exports
globalModule.exports.process = process;
globalModule.exports.global = typeof window !== 'undefined' ? window : globalThis;

// Stream polyfills
if (typeof window !== 'undefined') {
  const Stream = { Readable, Writable, Duplex, Transform, PassThrough };
  (window as any).Stream = Stream;
  (globalThis as any).Stream = Stream;
  globalModule.exports.Stream = Stream;
}

// TextEncoder/TextDecoder polyfill
if (typeof window !== 'undefined') {
  if (typeof window.TextEncoder === 'undefined') {
    (window as any).TextEncoder = window.TextEncoder || TextEncoder;
    (globalThis as any).TextEncoder = window.TextEncoder || TextEncoder;
    globalModule.exports.TextEncoder = window.TextEncoder || TextEncoder;
  }
  if (typeof window.TextDecoder === 'undefined') {
    (window as any).TextDecoder = window.TextDecoder || TextDecoder;
    (globalThis as any).TextDecoder = window.TextDecoder || TextDecoder;
    globalModule.exports.TextDecoder = window.TextDecoder || TextDecoder;
  }
}

// Ensure all polyfills are available in the global scope
if (typeof window !== 'undefined') {
  // Add any missing global functions
  if (!(window as any).setImmediate) {
    (window as any).setImmediate = setTimeout;
  }
  if (!(window as any).clearImmediate) {
    (window as any).clearImmediate = clearTimeout;
  }
}
